import { render, staticRenderFns } from "./ErrorListRoute.vue?vue&type=template&id=88db59d6&scoped=true&"
import script from "./ErrorListRoute.vue?vue&type=script&lang=js&"
export * from "./ErrorListRoute.vue?vue&type=script&lang=js&"
import style0 from "./ErrorListRoute.vue?vue&type=style&index=0&id=88db59d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88db59d6",
  null
  
)

export default component.exports